// export const  CONTRACT_ADDRESS="TWwv1fiXeksWiXg9CqPG2NgdrXnjLXipxi";
export const  CONTRACT_ADDRESS="TJn3ZS32Zi1MsxuPCYrUoCLzD5CDxq8a96";
export const  refDefaultAddress="TFEhnHMA5ffG6dFTaV4ozKS3TMqkBnU5BH";
// export const  CONTRACT_ADDRESS="TU9ZFgGQSgTVtirLHc6KqVkpAgedNCXrdg";
// export const  CONTRACT_ADDRESS="TVBXz82ARjNckWpM4wttrfaU4KmHXuZqi7";